export default __webpack_public_path__ + "static/media/kingdom_tel_1.a9212f7c.jpg";